import React from 'react'

const Sales_Orders = () => {
  return (
    <div>
      sales orders page
    </div>
  )
}

export default Sales_Orders
